<span
  class="so-loader"
  [style.width]="size()"
  [style.height]="size()"
  [style.--so-loader-color]="resolvedColor()"
></span>
